import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SearchCoreDropdown, { DropdownValueChange } from './SearchCoreDropdown';
import API from '../API';

interface BusinessBanksDropdownProps{
	label?: string,
	placeholder?: string,
	value?: any,
	style?: React.CSSProperties,
	onValueChange?: DropdownValueChange,
}

var BusinessBanksDropdown = (props: BusinessBanksDropdownProps)=>{
	var { t } = useTranslation();
	return <SearchCoreDropdown
		style={props.style}
		label={props.label || t('common.bank')}
		placeholder={props.placeholder}
		value={props.value}
		onValueChange={props.onValueChange}
		onShowLoad={()=>{
			return API.getBusinessBanks();
		}}
		searchData={q=>{
			return API.getBusinessBanks(q);
		}}
		renderItem={a=>({
			text: a.bank_name,
			value: a.bank_id,
			meta: `ID: ${a.bank_id}`,
		})}
	/>
}

export default BusinessBanksDropdown;